import xhr from '../../tools/xhr.js';
import auth from '../../tools/storage.js';

import tools from '../../tools/tools.js';;


const mainTabPane = document.querySelector('#b2bDocsParntersCimena');

const btExport = mainTabPane.querySelector('button[name=btExport]');

const exportBody = document.querySelector('#excelExportFIELD');


btExport.addEventListener('click', function () {

    xhr.request = {
            metod: 'GET',
            url: `b2b/x/exportExcel/`,
            data: '',
            callbackSuccess: onSuccessLoadExportData
          };
});

let limitStep = 0;
let allFileds = '';
let tableHTML = '';
let allCreators = [];
let tableHTMLCreator = '';

const allColumnsPage1 = ['order_number','regionName','locCityName','locAddress', 'locName', 'userName','locRealPlays','locRealPeople'];

const onSuccessLoadExportData = (servarAnswer) => {

  if (servarAnswer.status === 200) {
      buildHeader(servarAnswer.message);
      buildBody(servarAnswer.data);
      makeExport();
  }
};

function buildHeader(nameFest) {
  let htmlBody = `<table id="tab1">
                    `;
  allColumnsPage1.forEach((element) => {
      htmlBody += `<td data-f-bold="true">${translateField(element)}</td>`;
  });
  htmlBody += '</tr>';
  tableHTML = htmlBody;

}

function stringAddValueOnKey(str, dct, key, needSpaceAfter){

  if(dct.hasOwnProperty(key) && dct[key]){
    str = `${str}${dct[key]}`;
    if(needSpaceAfter)
      str = `${str} `;
  }

  return str;

}
function removeSymbolInStartString(str , removeSymbol){

  if(str && str.length > 1) 
    if (removeSymbol === str.charAt(0))
      str = str.substring(1);
  
  return str;
}

function buildBody(dataServ) {
  // console.log(dataServ);
  let countRow = 0;
  if(dataServ) {
    dataServ.forEach((element) => {
      ++countRow;
        let rowHTML = '<tr><td>' + countRow + '</td>';

        allColumnsPage1.forEach((column) => {
          {

            if(element.hasOwnProperty(column)) {
              let someValue = element[column];
              // console.log(someValue);
              if (someValue)
                rowHTML += `<td>${someValue}</td>`;
              else
                rowHTML += `<td>-</td>`;
             }
           }
        });
      rowHTML += '</tr>';
      // console.log(rowHTML);
      tableHTML = tableHTML +  rowHTML;
    }); 

    tableHTML = tableHTML + '</table>';
    exportBody.innerHTML = tableHTML;
  } else
    alert('Таблица пуста');
}

function translateField(nameField){
  if(nameField === 'order_number')
    return '№';
  else if(nameField === 'regionName')
    return 'Субъект Российской Федерации';
  else if(nameField === 'locCityName')
    return 'Наименование населенного пункта';
  else if(nameField === 'locAddress')
    return 'Фактический адрес площадки';
  else if(nameField === 'locName')
    return 'Наименование площадки/кинотеатра';
  else if(nameField === 'userName')
    return 'Наименование курирующей организации';
  else if(nameField === 'locRealPlays')
    return 'Кол-во показов';
  else if(nameField === 'locRealPeople')
    return 'Кол-во зрителей';
  else
    return '-';

}
function makeExport(argument) {

  let wb = TableToExcel.initWorkBook();
  wb = TableToExcel.tableToSheet(wb, document.getElementById("tab1"), {
              name: `fest_${auth.currentFestival}.xlsx`,
              sheet: {
              name: "Заявленные работы"
              }});
  TableToExcel.save(wb, `fest_${auth.currentFestival}.xlsx`);
}



export default {

  start() {
    // menuBt.addEventListener('click', reloadInitSettings);
  },


  stop() {
    // pointsMarkup.cleanContainer();
  }
};
